/**
 * Debug utility for conditional console logging
 * Only logs in development environment
 */

/**
 * Check if we're in development mode
 */
function isDevelopment() {
  return window.viploge?.env === 'dev';
}

/**
 * Console.log wrapper that only logs in development
 */
export function debugLog(...args) {
  if (isDevelopment()) {
    console.log(...args);
  }
}

/**
 * Console.error wrapper that only logs in development
 */
export function debugError(...args) {
  if (isDevelopment()) {
    console.error(...args);
  }
}

/**
 * Console.warn wrapper that only logs in development
 */
export function debugWarn(...args) {
  if (isDevelopment()) {
    console.warn(...args);
  }
}

/**
 * Console.info wrapper that only logs in development
 */
export function debugInfo(...args) {
  if (isDevelopment()) {
    console.info(...args);
  }
}
